import React, { useEffect, useRef } from 'react';
import { StyledArticleProducts } from './StyledArticleProducts';
import { gsap } from "gsap";
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ArticleProducts = ({ align, introText, introHighlight, img, imgSize, title, articleText, link, classToAdd, extraPadding }) => {
  const imageBg = useRef(null);

  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      setTimeout(() =>{  
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }

  useEffect(() => {
    gsap.to(imageBg.current, {
      duration: .75,
      ease: "power2.easeInOut",
      scale: 1.1,
      scrub: 1,
      scrollTrigger: {
        trigger: imageBg.current,
        start: "top center"
      }
    })
  }, [])
  return (
    <React.Fragment>
      {
       
          <StyledArticleProducts className={`${align} ${classToAdd}`} extraPadding={extraPadding}>
            {
              introText &&
              <p className="preset-9 intro--article">{introText} <span>{introHighlight}</span></p>
            }
            {
              img && 
              <div className={`article--figure ${imgSize}`}>
                <img ref={imageBg} src={img} />
              </div>
            }
            <div className="article--wrap">
              <h5 className="big--title">{title}</h5>
              <p className="preset-11 article--text">{articleText}</p>
              
              {
                link &&
                <div className="cta--primary primary-green cursor-cta" onClick={() => handleCLick(link)}>
                  <p className="preset-10 primary-green cursor-cta">Explore</p>
                  <img className="next cursor-cta" src={require("../../assets/cta-arrow-next-green.svg")} />
                </div>
              } 

            </div>
          </StyledArticleProducts>
          
      }
    </React.Fragment>
  );
};

export default ArticleProducts;
